/**
 * Basic Responsive tabs
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';
import _delay from 'lodash/delay.js';


class ResponsiveTabs extends Script {
    constructor($tabs) {
        super();

        this.$tabs = $tabs;

        // clear whitespace
        this.$tabs.find('ul').contents().filter(function () {
            return (this.nodeType == 3 && !/\S/.test(this.nodeValue));
        }).remove();

        this.$buttons = this.$tabs.find('> nav > ul > li');

        this._initButtons();

        $tabs.find('> .tab-container').show();

        if (!this._parseHash()) $tabs.find('> nav li a').eq(0).trigger('click');
    }

    onResize() {
        // make sure that in full mode at least one tab is selected
        const selected = this.$tabs.find('> nav li.active').length;

        if (this._isBig() && !selected) {
            this.$tabs.find('> nav li').eq(0).trigger('click');
        }

        if (this.$edit) this._removeEdit();
    }

    _initButtons() {
        let index = 0;
        this.$buttons.each((_, button) => {
            const $button = $(button);
            if ($button.hasClass('group')) {
                index = this._initGroup($button, index);
                this._fixOrder($button.find('ul').eq(0));
            }
            else this._initButton($button, index++, $button.text());
        });
    }

    _initGroup($group, index) {
        // initialise inner buttons
        $group.find('li').each((i, button) => {
            const $button = $(button);
            const name = `${$group.data('item')} ${i + 1}`;
            $button.addClass('group-item');
            this._initButton($button, index++, name, true);
        });

        // expand group on click
        $group.on('click', () => this._expandGroup($group));

        // add add button to nav
        const $add = $('<li class="add"><a>+</a></li>');
        $group.find('ul').append($add);

        // add add button to accordion
        const $section = $('<article><header><div class="tab-header add">');
        const name = $group.data('item');
        const $header = $section.find('.tab-header');
        $header.append(`<a>Add ${name}</a>`);

        const sel = '> .tab-container > article';
        const $lastSection = this.$tabs.find(sel).eq(index - 1);
        $section.insertAfter($lastSection);

        $add.add($header).on('click', () => {
            if (!$add.hasClass('locked')) {
                this._addItem($group, $section, $add);
            }
        });

        return index + 1; // + add button
    }

    _expandGroup($group) {
        if ($group.hasClass('active')) return;

        this._allInactive();
        $group.addClass('active');

        $group.find('> ul > li').eq(0).trigger('click');
    }

    _addItem($group, $section, $add) {
        const index = $group.find('li').length;
        const name = `${$group.data('item')} ${index}`;

        const href = $group.data('item').toLowerCase() + index;
        const $button = $(`<li><a href="#${href}">${index}</a></li>`);
        $button.addClass('group-item');
        $button.insertBefore($add);
        $button.find('a').on('click', function (e) { e.preventDefault(); });

        const $article = $('<article>');
        const $header = $('<header>');
        const $tabHeader = $('<div class="tab-header">');

        $(`<a class="name">${name}</a>`).appendTo($tabHeader);
        this._initGroupHeader($tabHeader, $button, $article);

        const $outer = $('<section><div class="tab-inner"></div></section>');

        $tabHeader.appendTo($header);
        $article.append($header).append($outer).insertBefore($section);
        $button.data('article', $article);
        $article.data('button', $button);

        const $inner = $outer.find('.tab-inner');
        const $template = $($group.data('template'));
        $inner.append($template.children().clone());
        injector.newHtml($inner);

        $tabHeader.add($button).on('click', () => this._click($button, $inner));
        $tabHeader.trigger('click');

        this._fixOrder($group.find('ul').eq(0));
    }

    _allInactive() {
        this.$tabs.find('li.active, .tab-inner.active').removeClass('active');
    }

    _initButton($button, index, text, group = false) {
        const sel = '> .tab-container > article';
        const $section = this.$tabs.find(sel).eq(index);
        $section.wrapInner('<section><div class="tab-inner">');

        const title = `<a class="name">${text}</a>`;
        const $header = $('<div class="tab-header">').append(title);
        $section.prepend($('<header>').append($header));

        if (group) this._initGroupHeader($header, $button, $section);

        $button.find('a').on('click', function (e) { e.preventDefault(); });
        $button.data('article', $section);
        $section.data('button', $button);

        const $inner = $section.find('.tab-inner');
        $header.add($button).on('click', () => this._click($button, $inner));
    }

    _initGroupHeader($header, $button, $section) {
        $('<a href="#up">[up]</a>').appendTo($header).on('click', () => {
            this._moveLeft($button, $section);
            this._fixOrder($button.closest('ul'));
            return false;
        });

        $('<a href="#down">[down]</a>').appendTo($header).on('click', () => {
            this._moveRight($button, $section);
            this._fixOrder($button.closest('ul'));
            return false;
        });

        $('<a href="#remove">[x]</a>').appendTo($header).on('click', () => {
            const $ul = $button.closest('ul');
            this._removeItem($button, $section);
            this._fixOrder($ul);
            return false;
        });
    }

    _click($button, $section) {
        if ($button.hasClass('active')) {
            if (!this._isBig()) this._allInactive();

            else if ($button.hasClass('group-item')) {
                if (!$button.hasClass('locked')) {
                    this._edit($button, $section);
                }
            }

            return;
        }

        this._allInactive();
        $button.addClass('active');
        $button.parents('li').addClass('active');
        $section.addClass('active');

        const $a = $button.find('a');
        const url = $a.attr('href') ? $a.attr('href') : '';
        if (url) {
            this.setState({}, url, true);
            if (this.$tabs.data('out-href')) {
                $(this.$tabs.data('out-href')).val(url);
            }
        }
    }

    _parseHash() {
        if (location.hash.length) {
            const id = location.hash;
            const $el = this.$buttons.find(`a[href='${id}']`)
                .parents('li').eq(0);
            if ($el.length) {
                $el.trigger('click');
                return true;
            }
        }
        return false;
    }

    _isBig() {
        return this.$tabs.find('> nav').is(':visible');
    }

    _edit($button, $section) {
		this._removeEdit();

        this.$edit = $('<div class="responsive-edit">').prependTo('body');
		this.$edit.data('group', $button.closest('ul'));
        this.$edit.on('click', () => {
			this._removeEdit();
        });

        const width = $button.outerWidth();
        const hwidth = Math.floor(width / 2);
        const height = $button.outerHeight();
        const hoffset = width * 0.6;

        const top = $button.offset().top;
        const left = $button.offset().left;
        const middle = left + hwidth;

        let arrows = false;

        arrows = true;
        const $left = $('<a class="left">').appendTo(this.$edit);
        $left.offset({ top, left: middle - hoffset - $left.outerWidth() });
        $left.on('click', () => {
            this._moveLeft($button, $section);
            this._removeEdit();
            _delay(() => this._edit($button, $section), 10);
            return false;
        });

        if (!$button.next().hasClass('add')) {
            arrows = true;
            const $right = $('<a class="right">').appendTo(this.$edit);
            $right.offset({ top, left: middle + hoffset });
            $right.on('click', () => {
				this._moveRight($button, $section);
				this._removeEdit();
				_delay(() => this._edit($button, $section), 10);
				return false;
			});
        }

        if (arrows) {
            const $cross = $('<a class="remove">').appendTo(this.$edit);
            $cross.offset({ top: top - height, left });
            $cross.on('click', () => this._removeItem($button, $section));
        }
        else this._removeEdit();
    }

	_removeEdit() {
        if (this.$edit) {
			this._fixOrder(this.$edit.data('group'));
            this.$edit.remove();
            this.$edit = null;
            return;
        }
	}

	_fixOrder($ul) {
        const $group = $ul.closest('.group');
        $ul.children('li:not(.add)').each((index, li) => {
            const $li = $(li);
            const href = $group.data('item').toLowerCase() + (index + 1);
            $li.find('a').html(index + 1).attr('href', `#${href}`);

            const name = `${$group.data('item')} ${index + 1}`;

            const $article = $li.data('article');
            $article.find('.tab-header a.name').html(name);

            const $header = $article.find('.tab-header');

            if (!index) $header.find('[href="#up"]').hide();
            else $header.find('[href="#up"]').show();

            if (index + 2 >= $ul.children().length) {
                $header.find('[href="#down"]').hide();
            }
            else $header.find('[href="#down"]').show();

            if ($ul.children().length === 2) {
                $header.find('[href="#remove"]').hide();
            }
            else $header.find('[href="#remove"]').show();
        });
	}

    _moveLeft($button, $section) {
        $button.insertBefore($button.prev());

        const $article = $section.closest('article');
        $article.insertBefore($article.prev());
    }

    _moveRight($button, $section) {
        $button.insertAfter($button.next());

        const $article = $section.closest('article');
        $article.insertAfter($article.next());
    }

    _removeItem($button, $section) {
        let $next = $button.next();
        if ($next.hasClass('add')) $next = $button.prev();

        $button.remove();
        $section.closest('article').remove();

        $next.trigger('click');
    }
}

injector.injectClass(class extends Script {
    onLoad() {
        this.tabs = [];
        $('.responsive-tabs').each((_, el) => {
            this.tabs.push(new ResponsiveTabs($(el)));
        });
    }

    onState(state) {
        if (state.tabs) Object.keys(state.tabs).forEach((tab) => {
            $(`#${tab}`).data().onState(state.tabs[tab]);
        });
    }

    onResize() {
        this.tabs.forEach((tabs) => tabs.onResize());
    }
});
